import React from 'react';

const Faq = ({ items }) => (
  <div className="cp-faq">
    {items.map((it, i) => (
      <details className="cp-faq-item" key={i}>
        <summary>{it.q}</summary>
        <div className="cp-faq-item-body">{it.a}</div>
      </details>
    ))}
  </div>
);

export default Faq;
